import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import { faHeart } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Button, Card, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Counter } from "../../../targets/widgets/counter";
import { useCustomFoodDetail } from "../queries";
import "../styles.scss";

export function RecipeDetailViewCard() {
    const { id } = useParams<{ id: string }>();
    const { t } = useTranslation();
    const { data: food, isLoading, isError } = useCustomFoodDetail(id!);
    const [servings, setServings] = useState(1);

    useEffect(() => {}, [id]);
    useEffect(() => {}, [isLoading, isError, food]);
    useEffect(() => {}, [servings]);

    if (isLoading) {
        return (
            <Card className="container recipe-info mt-2 p-2 text-center">
                <Spinner animation="border" />
                <p>{t("Loading recipe...")}</p>
            </Card>
        );
    }

    if (!food || isError) {
        return <div className="p-4 text-center">{t("Recipe not found.")}</div>;
    }

    return (
        <Card
            className="container p-3 custom-recipe-detail"
            style={{ backgroundColor: "#efefef", border: "none" }}
        >
            <Button
                variant="link"
                className="dark-button mb-3"
                onClick={() => {}}
            >
                <FontAwesomeIcon icon={faChevronLeft} className="mr-1" />{" "}
                {t("Back")}
            </Button>

            <div className="d-flex justify-content-between align-items-start mb-3">
                <div>
                    <h3 className="font-weight-bold">{food.food_name}</h3>
                    <div className="text-muted">
                        {0} Ingredients • {Math.round(food.nf_calories || 0)}{" "}
                        Cal
                    </div>
                </div>
                <FontAwesomeIcon icon={faHeart} color="#AF0505" size="lg" />
            </div>

            <div className="mb-3">
                <span>{t("Servings")}</span>
                <Counter
                    minValue={1}
                    counterskip={1}
                    value={servings}
                    onChange={(val) => {
                        setServings(val);
                    }}
                    maxValue={50}
                    labelVale={food.serving_unit}
                    styles={{ border: "none" }}
                />
            </div>

            {/* Total Calories */}
            <Card className="p-3 mb-4">
                <div className="d-flex justify-content-between">
                    <strong>{t("recipe_book.total_calories")}</strong>
                    <span>
                        {Math.round((food.nf_calories || 0) * servings)} kcal
                    </span>
                </div>
            </Card>

            <Card className="p-4 mb-4">
                <h4>{t("recipe_book.ingredients")}</h4>
            </Card>

            <div className="d-flex justify-content-end">
                <Button
                    variant="outline-primary"
                    className="shadow-none p-0 m-auto d-flex align-items-center btn-naked-primary"
                >
                    {t("Edit")}
                </Button>
                <Button variant="primary">{t("recipe_book.log_recipe")}</Button>
            </div>
        </Card>
    );
}
